import { ButtonProps, ModalFuncProps } from 'antd';
import { TestProps } from 'core/utils/testTypes';
import { FC, ReactNode } from 'react';
import { colors } from 'theme';
import { TextSmall } from '../typography';
import { StyledModal } from './Modal.styles';

interface Props extends ModalFuncProps, TestProps {
    contentText?: string;
    children?: ReactNode;
    confirmText?: string | React.ReactNode;
    cancelText?: string;
    equalButtons?: boolean;
    footer?: React.ReactNode;
    disabledOkButton?: boolean;
    testId?: string;
}

const Modal: FC<Props> = (props) => {
    const { equalButtons } = props || false;

    const okButtonProps: ButtonProps & TestProps = equalButtons
        ? {
              disabled: props.disabledOkButton,
              testId: `ok-button-${props.testId ?? ''}`,
              style: {
                  color: `white`,
                  background: colors.brand6,
                  borderRadius: '8px',
                  height: '32px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  fontSize: '14px',
                  border: 'none',
                  padding: '16px',
              },
              size: 'large',
          }
        : {
              disabled: props.disabledOkButton,
              style: {
                  color: `white`,
                  background: colors.brand5,
                  borderRadius: '8px',
                  height: '32px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  fontSize: '14px',
                  border: 'none',
                  padding: '16px',
              },
              size: 'large',
              testId: `ok-button-${props.testId ?? ''}`,
          };

    const cancelButtonProps: ButtonProps & TestProps = {
        testId: `cancel-button-${props.testId ?? ''}`,
        style: {
            color: colors.grey9,
            background: `white`,
            border: `1px solid #d9d9d9`,
            borderRadius: '8px',
            fontSize: '14px',
            height: '32px',
            display: 'inline-flex',
            alignItems: 'center',
            padding: '16px',
        },
        size: 'large',
    };

    return (
        <StyledModal
            centered
            data-testid={props.testId}
            okText={props.confirmText ?? 'Yes, remove'}
            okButtonProps={okButtonProps}
            cancelText={props.cancelText ?? "Don't remove"}
            cancelButtonProps={cancelButtonProps}
            {...props}
        >
            {props.contentText && <TextSmall>{props.contentText}</TextSmall>}
            {props.children}
        </StyledModal>
    );
};

export default Modal;
